import { render } from "./App.vue?vue&type=template&id=ce559e22"
const script = {}

import "./App.vue?vue&type=style&index=0&id=ce559e22&lang=scss"

import exportComponent from "/builds/frontend/specialist-cooperation-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__